import React from 'react';
import { remainingDays } from '@jumbo/utils/dateHelper';
import Tooltip from '@material-ui/core/Tooltip';
import { Box, Typography } from '@material-ui/core';
import { AccessTime, CloudUpload, Bookmark, Delete } from '@material-ui/icons';
import { ContentPaste, ForwardToInbox } from '@mui/icons-material';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FONT_SIZE_UPLOAD } from 'config/config';

const normalizeToArray = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return [value];
};

const safeParseAntecedente = (value) => {
  if (!value) return null;

  if (typeof value === 'object') return value;

  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }

  return null;
};



const getIconAntecedentes = antecedente => {
  if (antecedente === 'Antecedentes médicos') {
    return <ContentPaste style={{ marginLeft: 2, marginTop: 2, marginRight: 2 }} />;
  } else {
    return <ForwardToInbox style={{ marginLeft: 2, marginTop: 2, marginRight: 2 }} />;
  }
};

export const getNomEtapa = (nom_etapa_extranet) => {
  if (nom_etapa_extranet === "" || nom_etapa_extranet === null) {
    return "Sin etapa asignada"
  } else {
    return nom_etapa_extranet
  }
}

export const getDatosEntidadesList = (entidad, gest) => {

  let datos = {
    ...entidad,
    fechaIngreso: (
      <Box
        sx={{
          display: 'inline-flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <div
          style={{
            backgroundColor: '#3497dc',
            borderRadius: 25,
            color: 'white',
            paddingLeft: 10,
            paddingRight: 10,
            fontSize: 12,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {entidad.fecha_ingreso.split('-').join('/')}
          <div>
            <AccessTime style={{ color: 'white', marginLeft: 2, marginTop: 2 }} />
          </div>
        </div>

      </Box>
    ),
    fechaEtapa: (
      <Box
        sx={{
          display: 'inline-flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <div
          style={{
            backgroundColor: '#3497dc',
            borderRadius: 25,
            color: 'white',
            paddingLeft: 10,
            paddingRight: 10,
            fontSize: 12,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {entidad.fecha_etapa.split('-').join('/')}
          <div>
            <AccessTime style={{ color: 'white', marginLeft: 2, marginTop: 2 }} />
          </div>
        </div>
      </Box>
    ),
    vencimiento_raw: entidad.fecha_vencimiento === '' ? entidad.fecha_etapa : entidad.fecha_vencimiento, //aca va el dato crudo de la fecha de vencimiento
    antecedentes_raw: entidad.antecedentes_solicitados, //dato crudo de los antecedentes
    nombre_rec_tabla: <div style={{ color: 'blue' }}>{entidad.nombre_rec}</div>,
    etapa_actual_tabla: (
      <div
        style={{
          color: 'white',
          backgroundColor: '#3497dc',
          fontWeight: 'normal',
          display: 'inline-block',
          borderRadius: '5px',
          paddingLeft: 5,
          paddingRight: 5,
        }}>


        {
          gest ? getNomEtapa(entidad.nom_etapa_extranet) : entidad.etapa_actual

        }

      </div>
    ),
    vencimiento: (
      <Tooltip title={'fecha de ingreso: ' + entidad.fecha_ingreso}>
        <Box
          sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          style={{
            backgroundColor:
              entidad.fecha_vencimiento === ''
                ? remainingDays(entidad.fecha_etapa)
                : remainingDays(entidad.fecha_vencimiento),
            borderRadius: 25,
            color: 'white',
            paddingLeft: 10,
            paddingRight: 10,
            fontSize: 12,
          }}>
          <div
            style={{
              lineHeight: 1.5,
              verticalAlign: 'middle',
              display: 'inline',
            }}>
            {entidad.fecha_vencimiento === '' ?
              getDatadate(entidad.fecha_etapa)
              :
              getDatadate(entidad.fecha_vencimiento.split('-').join('/'))}
          </div>
          <div>
            <AccessTime style={{ color: 'white', marginLeft: 2, marginTop: 2 }} />
          </div>
        </Box>
      </Tooltip>
    ),
    antecedentes_solicitados:
      entidad.etapa_actual === 'Espera respuesta del prestador' ||
        entidad.etapa_actual === 'Espera respuesta traslado' ||
        entidad.etapa_actual === 'Reitera traslado' ||
        entidad.etapa_actual === 'Reitera Solicitud Antecedentes' ? (
        /*
            'Espera respuesta traslado',
      'Reitera traslado',
      'Reitera Solicitud Antecedentes', 
       */
        entidad.nom_antecedente.length > 0 ? (
          <Tooltip
            title={normalizeToArray(entidad?.nom_antecedente)
              .map(safeParseAntecedente)
              .map(x => x?.adjunto)
              .filter(Boolean)
              .join(', ')
            }
          >

            <Box
              sx={{
                display: 'inline-flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              style={{ paddingLeft: 10, paddingRight: 10, fontSize: 12 }}>
              <div>
                {/* <InfoOutlined style={{ marginLeft: 2, marginTop: 2, marginRight: 2 }} /> */}
                {getIconAntecedentes(entidad.antecedentes_solicitados)}
              </div>
              <div
                style={{
                  lineHeight: 1.5,
                  verticalAlign: 'middle',
                  display: 'inline',
                }}>
                {entidad.antecedentes_solicitados}
              </div>
            </Box>
          </Tooltip>
        ) : (
          <Box
            sx={{
              display: 'inline-flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            style={{ paddingLeft: 10, paddingRight: 10, fontSize: 12 }}>
            <div>
              {/* <InfoOutlined style={{ marginLeft: 2, marginTop: 2, marginRight: 2 }} /> */}
              {getIconAntecedentes(entidad.antecedentes_solicitados)}
            </div>
            <div
              style={{
                lineHeight: 1.5,
                verticalAlign: 'middle',
                display: 'inline',
              }}>
              {entidad.antecedentes_solicitados}
            </div>
          </Box>
        )
      ) : (
        <Box
          sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          style={{ paddingLeft: 10, paddingRight: 10, fontSize: 12 }}>
          <div>
            {/* <InfoOutlined style={{ marginLeft: 2, marginTop: 2, marginRight: 2 }} /> */}
            {getIconAntecedentes(entidad.antecedentes_solicitados)}
          </div>
          <div
            style={{
              lineHeight: 1.5,
              verticalAlign: 'middle',
              display: 'inline',
            }}>
            {entidad.antecedentes_solicitados}
          </div>
        </Box>
      ),
  };

  return datos;
};

const getDatadate = (date) => {

  if (isValidDateDDMMYYYY(date)) {
    return date
  }
  else {
    return "00/00/0000"
  }
}

function isValidDateDDMMYYYY(dateString) {

  const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  if (!regex.test(dateString)) return false;
  const [day, month, year] = dateString.split("/").map(Number);
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() + 1 === month &&
    date.getDate() === day
  );
}

export const tableHeadCells = [
  /* derivaciones, mis asignaciones, todos los reclamos */
  {
    //id: 'n_reclamo',
    id: 'folio_presentacion',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'Folio',
  },
  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' },
  { id: 'nombre_rec_tabla', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_rec', alignContent: 'left', label: 'Rut' },
  { id: 'tipo_reclamo', alignContent: 'left', label: 'Tipo' },
  { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },
  {
    id: 'antecedentes_solicitados',
    alignContent: 'left',
    label: 'Antecedentes solicitados',
  },
  /* { id: 'vencimiento', alignContent: 'left', label: 'Vencimiento' }, */
  { id: 'fechaEtapa', alignContent: 'left', label: 'Fecha notificacion' },

];

export const tableHeadCellsDerivaciones = [
  /* derivaciones */
  {
    //id: 'n_reclamo',
    id: 'folio_presentacion',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'Folio',
  },
  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' },
  { id: 'nombre_rec_tabla', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_rec', alignContent: 'left', label: 'Rut' },
  { id: 'tipo_reclamo', alignContent: 'left', label: 'Tipo' },
  { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },
  {
    id: 'antecedentes_solicitados',
    alignContent: 'left',
    label: 'Antecedentes solicitados',
  },
  /* { id: 'vencimiento', alignContent: 'left', label: 'Vencimiento' }, */
  { id: 'fechaEtapa', alignContent: 'left', label: 'Fecha notificacion' },

];

export const tableHeadCellsIsRed = [
  /* derivaciones, mis asignaciones, todos los reclamos */
  {
    //id: 'n_reclamo',
    id: 'folio_presentacion',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'Folio',
  },
  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' },
  { id: 'nombre_rec_tabla', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_rec', alignContent: 'left', label: 'Rut' },
  { id: 'tipo_reclamo', alignContent: 'left', label: 'Tipo' },
  { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },
  {
    id: 'antecedentes_solicitados',
    alignContent: 'left',
    label: 'Antecedentes solicitados',
  },
  /* { id: 'vencimiento', alignContent: 'left', label: 'Vencimiento' }, */
  { id: 'reclamado', alignContent: 'left', label: 'Prestador' },
  { id: 'fechaEtapa', alignContent: 'left', label: 'Fecha notificacion' },

];

export const tableHeadCellsIsRedDerivaciones = [
  /* derivaciones, mis asignaciones, todos los reclamos */
  {
    //id: 'n_reclamo',
    id: 'folio_presentacion',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'Folio',
  },
  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' },
  { id: 'nombre_rec_tabla', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_rec', alignContent: 'left', label: 'Rut' },
  { id: 'tipo_reclamo', alignContent: 'left', label: 'Tipo' },
  { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },
  {
    id: 'antecedentes_solicitados',
    alignContent: 'left',
    label: 'Antecedentes solicitados',
  },
  /* { id: 'vencimiento', alignContent: 'left', label: 'Vencimiento' }, */
  { id: 'reclamado', alignContent: 'left', label: 'Prestador' },
  { id: 'fechaEtapa', alignContent: 'left', label: 'Fecha notificacion' },

];

export const tableHeadCellsEnEspera = [
  /* en espera respuesta prestador */
  {
    //id: 'n_reclamo',
    id: 'folio_presentacion',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'Folio',
  },
  /*  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' }, */

  { id: 'nombre_rec_tabla', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_rec', alignContent: 'left', label: 'Rut' },
  { id: 'tipo_reclamo', alignContent: 'left', label: 'Tipo' },
  { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },
  {
    id: 'antecedentes_solicitados',
    alignContent: 'left',
    label: 'Antecedentes solicitados',
  },
  { id: 'fechaEtapa', alignContent: 'left', label: 'Fecha notificacion' },
  { id: 'vencimiento', alignContent: 'left', label: 'Vencimiento' },
];

export const tableHeadCellsEnEsperaIsRed = [
  /* en espera respuesta prestador */
  {
    //id: 'n_reclamo',
    id: 'folio_presentacion',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'Folio',
  },
  /*  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' }, */

  { id: 'nombre_rec_tabla', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_rec', alignContent: 'left', label: 'Rut' },
  { id: 'tipo_reclamo', alignContent: 'left', label: 'Tipo' },
  { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },
  {
    id: 'antecedentes_solicitados',
    alignContent: 'left',
    label: 'Antecedentes solicitados',
  },
  { id: 'reclamado', alignContent: 'left', label: 'Prestador' },
  { id: 'fechaEtapa', alignContent: 'left', label: 'Fecha notificacion' },
  { id: 'vencimiento', alignContent: 'left', label: 'Vencimiento' },
];

export const tableHeadCellsGestionadosIsRed = [
  /* gestionados */
  {
    //id: 'n_reclamo',
    id: 'folio_presentacion',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'Folio',
  },
  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' },
  { id: 'nombre_rec_tabla', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_rec', alignContent: 'left', label: 'Rut' },
  { id: 'tipo_reclamo', alignContent: 'left', label: 'Tipo' },
  { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },
  { id: 'reclamado', alignContent: 'left', label: 'Prestador' },

  { id: 'ver', alignContent: 'center', label: 'Ver' },
];

export const tableHeadCellsGestionados = [
  /* gestionados */
  {
    //id: 'n_reclamo',
    id: 'folio_presentacion',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'Folio',
  },
  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' },
  { id: 'nombre_rec_tabla', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_rec', alignContent: 'left', label: 'Rut' },
  { id: 'tipo_reclamo', alignContent: 'left', label: 'Tipo' },
  { id: 'etapa_actual_tabla', alignContent: 'left', label: 'Etapa' },


  { id: 'ver', alignContent: 'center', label: 'Ver' },
];

export const validaciones = [
  {
    type: 'dateRange',
    target: 'fechaIngreso',
    title: 'Fecha',
  },
];

export const todosLosReclamosActions = [
  /*  { action: 'ver', label: 'Ver', icon: <Visibility /> }, */
  { action: 'autoAsignar', label: 'Autoasignar', icon: <Bookmark /> },
  { action: 'addAnt', label: 'Antecedentes', icon: <CloudUpload /> },
  /*  { action: 'addRec', label: 'Recursos', icon: <CloudUpload /> }, */
  { action: 'prorroga', label: 'Prórroga', icon: <AccessTime /> },
];

export const derivacionesActions = [
  /*  { action: 'ver', label: 'Ver', icon: <Visibility /> }, */
  { action: 'autoAsignar', label: 'Autoasignar', icon: <Bookmark /> },
  { action: 'addAnt', label: 'Antecedentes', icon: <CloudUpload /> },
  /*   { action: 'addRec', label: 'Recursos', icon: <CloudUpload /> }, */
  /* { action: 'prorroga', label: 'Prórroga', icon: <AccessTime /> }, */
];

export const misAsignacionesActions = [
  /*  { action: 'ver', label: 'Ver', icon: <Visibility /> }, */
  /* { action: 'autoAsignar', label: 'Autoasignar', icon: <Bookmark /> }, */
  { action: 'addAnt', label: 'Antecedentes', icon: <CloudUpload /> },
  /*   { action: 'addRec', label: 'Recursos', icon: <CloudUpload /> }, */
  { action: 'prorroga', label: 'Prórroga', icon: <AccessTime /> },
  { action: 'quitar', label: 'Quitar', icon: <Delete /> },
];

export const enEsperaRespuestaActions = [
  /*   { action: 'ver', label: 'Ver', icon: <Visibility /> }, */
  { action: 'autoAsignar', label: 'Autoasignar', icon: <Bookmark /> },
  { action: 'addAnt', label: 'Antecedentes/Recursos', icon: <CloudUpload /> },
  /*   { action: 'addRec', label: 'Recursos', icon: <CloudUpload /> }, */
  { action: 'prorroga', label: 'Prórroga', icon: <AccessTime /> },
];

export const targetName = [
  { tipo: 'otroRecurso', prefix: 'otro' },
  { tipo: 'recurso', prefix: 'recurso' },
  { tipo: 'infCumplimiento', prefix: 'inf_cumplimiento' },
  { tipo: 'copiaNotificacion', prefix: 'copia_notificacion' },
];

export const selectedType = [
  { tipo: 'adjuntos', prefix: 'doc_solicitado' },
  { tipo: 'otroRecurso', prefix: 'otro_adjunto' },
  { tipo: 'recurso', prefix: 'recurso' },
  { tipo: 'infCumplimiento', prefix: 'inf_cumplimiento' },
  { tipo: 'copiaNotificacion', prefix: 'copia_notificacion' },
];

const radioMaping = [
  {
    nombre: 'Adjuntos solicitados',
    tipo: 'adjuntos',
    etapas: [
      'Espera respuesta traslado',
      'Reitera traslado',
      'Reitera Solicitud Antecedentes',
      'Espera respuesta del prestador',
    ],
    via: '',
  },
  {
    nombre: 'Otros Adjuntos',
    tipo: 'otroRecurso',
    etapas: ['Archivo Transitorio (Espera Recurso)', 'Archivo definitivo'],
    via: '',
  },
  {
    nombre: 'Recurso',
    tipo: 'recurso',
    etapas: ['Archivo Transitorio (Espera Recurso)'],
    via: '',
  },
  {
    nombre: 'Informe cumplimiento',
    tipo: 'infCumplimiento',
    etapas: ['Archivo Definitivo', 'Archivo Transitorio (Espera Recurso)'],
    via: '',
  },
  {
    nombre: 'Copia de respuesta al reclamante',
    tipo: 'copiaNotificacion',
    etapas: ['Archivo Definitivo'],
    via: 'Derivación',
  },
];

export const getRadioMapped = reclamo => {
  if (reclamo) {
    // eslint-disable-next-line
    return radioMaping.map((item, index) => {
      if (index !== 1) {
        let auxEtapa = false;
        // eslint-disable-next-line
        item.etapas.map(etapa => {
          if (etapa + '' === reclamo.etapa_actual + '') {
            auxEtapa = true;
          }
        });

        if (auxEtapa) {
          if (item.via === '') {
            if (index === 0) {
              if (reclamo.is_docsolicitado_upload && reclamo.nom_antecedente.length > 0) {
                return (
                  <FormControlLabel
                    key={index}
                    value={item.tipo}
                    control={<Radio />}
                    label={<Typography style={{ fontSize: FONT_SIZE_UPLOAD }}>{item.nombre}</Typography>}
                  />
                );
              } else {
                return null;
              }
            } else if (index === 2) {
              if (reclamo.is_recurso_upload) {
                return (
                  <FormControlLabel
                    key={index}
                    value={item.tipo}
                    control={<Radio />}
                    label={<Typography style={{ fontSize: FONT_SIZE_UPLOAD }}>{item.nombre}</Typography>}
                  />
                );
              } else {
                return null;
              }
            } else if (index === 3) {
              if (reclamo.is_informe_upload) {
                return (
                  <FormControlLabel
                    key={index}
                    value={item.tipo}
                    control={<Radio />}
                    label={<Typography style={{ fontSize: FONT_SIZE_UPLOAD }}>{item.nombre}</Typography>}
                  />
                );
              } else {
                return null;
              }
            } else if (index === 4) {
              if (reclamo.is_copiarec_upload) {
                return (
                  <FormControlLabel
                    key={index}
                    value={item.tipo}
                    control={<Radio />}
                    label={<Typography style={{ fontSize: FONT_SIZE_UPLOAD }}>{item.nombre}</Typography>}
                  />
                );
              } else {
                return null;
              }
            }
          } else {
            if (item.via === reclamo.via_tramitacion) {
              return (
                <FormControlLabel
                  key={index}
                  value={item.tipo}
                  control={<Radio />}
                  label={<Typography style={{ fontSize: FONT_SIZE_UPLOAD }}>{item.nombre}</Typography>}
                />
              );
            } else {
              return null;
            }
          }
        } else {
          return null;
        }
      } else {
        /*         let auxEtapa = true;
        // eslint-disable-next-line
        item.etapas.map(etapa => {
          if (etapa === reclamo.etapa_actual) {
            auxEtapa = false;
          }
        });
        if (auxEtapa) {
          if (reclamo.is_antecedente_upload) {
            return (
              <FormControlLabel
                key={index}
                value={item.tipo}
                control={<Radio />}
                label={<Typography style={{ fontSize: FONT_SIZE_UPLOAD }}>{item.nombre}</Typography>}
              />
            );
          } else {
            return null;
          }
        } else {
          return null;
        } */
        return null;
      }
    });
  } else {
    return null;
  }
};

export const getRadioDefaultSelected = reclamo => {
  if (reclamo) {
    // eslint-disable-next-line
    return radioMaping.map((item, index) => {
      if (index !== 1) {
        let auxEtapa = false;
        // eslint-disable-next-line
        item.etapas.map(etapa => {
          if (etapa + '' === reclamo.etapa_actual + '') {
            auxEtapa = true;
          }
        });

        if (auxEtapa) {
          if (item.via === '') {
            if (index === 0) {
              if (reclamo.is_docsolicitado_upload && reclamo.nom_antecedente.length > 0) {
                return item.tipo;
              } else {
                return null;
              }
            } else if (index === 2) {
              if (reclamo.is_recurso_upload) {
                return item.tipo;
              } else {
                return null;
              }
            } else if (index === 3) {
              if (reclamo.is_informe_upload) {
                return item.tipo;
              } else {
                return null;
              }
            } else if (index === 4) {
              if (reclamo.is_copiarec_upload) {
                return item.tipo;
              } else {
                return null;
              }
            }
          } else {
            if (item.via === reclamo.via_tramitacion) {
              return item.tipo;
            } else {
              return null;
            }
          }
        } else {
          return null;
        }
      } else {
        let auxEtapa = true;
        // eslint-disable-next-line
        item.etapas.map(etapa => {
          if (etapa === reclamo.etapa_actual) {
            auxEtapa = false;
          }
        });
        if (auxEtapa) {
          if (reclamo.is_antecedente_upload) {
            return item.tipo;
          } else {
            return null;
          }
        } else {
          return null;
        }
      }
    });
  } else {
    return null;
  }
};
